import {useEffect, useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {ContactGroup} from "../typedefs";

export function useGetContactGroup(id: string | undefined) {
    const [data, setData] = useState<ContactGroup | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!id) return;
        setIsLoading(true);
        setError(false);
        platformAPI.get<ContactGroup>(`api/contact-groups/${id}`)
            .then(res => setData(res.data))
            .catch(() => setError(true))
            .finally(() => setIsLoading(false));
    }, [id]);

    return {data, isLoading, error};
}
